<template>
<div class="loginContainer">
  <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h2 class="title">嘻游记后台管理系统</h2>
    <el-form-item prop="account">
      <el-input type="text" prefix-icon="el-icon-user" v-model="loginForm.account" auto-complete="off" placeholder="请输入账号"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" prefix-icon="el-icon-lock" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码"></el-input>
    </el-form-item>
    <!--<el-form-item >-->
      <!--<el-col :span="12">-->
        <!--<el-form-item prop="captcha">-->
          <!--<el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="验证码, 单击图片刷新"-->
            <!--style="width: 100%;">-->
          <!--</el-input>-->
        <!--</el-form-item>-->
      <!--</el-col>-->
      <!--<el-col class="line" :span="1">&nbsp;</el-col>-->
      <!--<el-col :span="11">-->
        <!--<el-form-item>-->
            <!--<img style="width: 100%;" class="pointer" :src="loginForm.src" @click="refreshCaptcha">-->
        <!--</el-form-item>-->
      <!--</el-col>-->
    <!--</el-form-item>-->
    <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
    <!-- 忘记密码 -->
    <div class="links">
       <!--<router-link class="retrieve" to='/login'>忘记密码</router-link>-->
    </div>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:48%;background-color: grey;border: 1px solid grey" @click.native.prevent="reset" >重 置</el-button>
      <el-button type="primary" style="width:48%;" @click.native.prevent="login" native-type="submit" :loading="loading">登 录</el-button>
    </el-form-item>
  </el-form>
  <h3 style="position: fixed;bottom: 30px;left:41%;font-size: 14px;color: gray;text-align: center">Copyright2021 - 2022 武汉嘻游记动漫有限公司版权所有</h3>
  <h3 style="position: fixed;bottom: 10px;left:44.5%;font-size: 14px;color: gray;text-align: center">深圳市逍遥软件科技提供技术支持</h3>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
export default {
  name: 'Login',
  components:{
    ThemePicker,
    LangSelector
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if(value === ''){
        callback(new Error('请输入密码'));
      }else{
        if(!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{3,20}$/.test(value)){
          callback(new Error('密码必须为3-20位字母和数字组合'))
        }else{
          callback()
        }
      }
    };
    return {
      loading: false,
      loginForm: {
        account: '',
        password: '',
        captcha:'',
        src: ''
      },
      fieldRules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      checked: true,
    }
  },
  methods: {
    enterLogin() {
      document.onkeydown = (e) =>{
        if(this.$router.path == '/login' && (e.code == 'Enter' || e.code == 'enter')) {
          this.login()
        }
      }
    },
    login() {
      if (this.loginForm.account.length <= 0 || this.loginForm.password.length <= 0) {
        return false
      }

      this.loading = true
      let userInfo = {account:this.loginForm.account, password:this.loginForm.password}
      
      this.$api.login.login(userInfo).then((res) => {
        if(res.code == 200) {
            this.$message({
                message: res.msg,
                type: 'success'
            })
          Cookies.set('token', res.data.token, 2) // 放置token到Cookie
          Cookies.set('user', userInfo.account, 2) // 放置token到Cookie
          sessionStorage.setItem('name', res.data.name) // 保存用户到本地会话
          sessionStorage.setItem('registeInfo', res.data.created_at)
          sessionStorage.setItem('id', res.data.id)
          sessionStorage.setItem('user', userInfo.account)
          this.$store.commit('menuRouteLoaded', false) // 要求重新加载导航菜单
          this.$router.push('/')  // 登录成功，跳转到主页
        } else {
            this.$message({
                message: res.message,
                type: 'error'
            })
        }
         this.loading = false
        }).catch((res) => {
          this.$message({
          message: res.message,
          type: 'error'
          })
        this.loading = false
        });
    },
    refreshCaptcha: function(){
      this.loginForm.src = this.global.baseUrl + "/captcha.jpg?t=" + new Date().getTime();
    },
    reset() {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  created() {
    this.enterLogin()
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor
    })
  }
}
</script>


<style lang="scss">
.loginContainer{
  .el-dialog__header{
    padding: 0px;
  }
  .el-dialog__body{
    padding: 10px;
  }
  .el-dialog{
    margin-top: 120px !important;
  }
  .el-input{
    .el-input__prefix{
      left: 0;
      width: 48px;
    }
    .el-input__inner{
      padding-left: 60px;
    }
    .el-input__prefix::after{
      content: "";
      width: 1px;
      height: 18px;
      background-color: #b8b8b8;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.loginContainer{
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(../assets/background2.jpg) no-repeat;
  background-size: 100% 100%;
}
  .login-container {
    position: relative;
    width: 350px;
    margin: 180px auto;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    padding: 35px 35px 15px 35px;
    background:rgba(255,255,255,.2);
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 50px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
    .links{
      height: 30px;
      line-height: 30px;
      text-align: right;
      font-size: 14px;
      margin-bottom: 15px;
      a{
        text-decoration: none;
        color: #333;
      }
    }
    
  }
  .btnColor{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
  }
  .mark{
    position: absolute;
    bottom: 20px;
    font-size: 12px;
    color: #666;
    left: 50%;
    transform: translateX(-50%);
  }
</style>


// WEBPACK FOOTER //
// src/views/Login.vue